<template>
  <div id="paginaContratti">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <!-- Timer Alert -->
      <b-col
          xl="6"
          md="12"
      >
        <b-alert
            :show="alertADismissCountDown"
            dismissible
            variant="warning"
            @dismissed="alertADismissCountDown = 0"
            @dismiss-count-down="alertACountDownChanged"
        >
          <p>Occorre selezionare una riga della tabella</p>
          <b-progress
              variant="warning"
              :max="alertADismissSecs"
              :value="alertADismissCountDown"
              height="4px"
          />
        </b-alert>
      </b-col>

      <b-col
          xl="12"
          md="12"
          class="pt-1"
      >

        <ejs-grid
            id="gridA"
            ref="gridA"
            :dataSource="contrattiFullData"
            :allowSorting="true"
            :toolbarClick="gridAClickHandler"
            :toolbar="gridA.toolbarOptions"
            :height="gridA.height"
            :allowFiltering="true"
            :filterSettings="gridA.filterOptions"
            :editSettings="gridA.editOptions"
            :actionBegin="gridAactionBegin"
            :actionComplete="gridAactionComplete"
        >
          <e-columns>
            <e-column
                field="id"
                headerText="ID"
                :isPrimaryKey="true"
                width="20"
            ></e-column>
            <e-column
                field="cognome"
                headerText="Cognome"
                width="60"
            ></e-column>
            <e-column
                field="nome"
                headerText="Nome"
                width="40"
            ></e-column>
            <e-column
                field="bozza"
                headerText="Bozza Contratto"
                width="150"
            ></e-column>
          </e-columns>
        </ejs-grid>
      </b-col>
    </b-row>

    <!-- dialogA: dialogDettaglioArtista ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog
        id="dialogA"
        ref="dialogA"
        :header="dialogA.header"
        :buttons="dialogA.buttons"
        :visible="dialogA.visible"
        :showCloseIcon="dialogA.showCloseIcon"
        :close="dialogAClose"
        :open="dialogAOpen"
        :zIndex="dialogA.zIndex"
        :animationSettings="dialogA.animationSettings"
    >
      <b-row class="match-height">

        <!-- Card con Elementi Input: anagrafica artista -->
        <b-col
            xl="6"
            md="12"
        >
          <b-card
              tag="article"
              class="mb-2"
          >
            <b-card-header class="align-items-baseline">
              <div>
                <b-card-title>Contratto</b-card-title>
                <b-card-text class="mb-0" />
              </div>
              <b-dropdown
                  variant="link"
                  no-caret
                  right
                  class="chart-dropdown"
                  toggle-class="p-0"
              >
                <template #button-content>
                  <feather-icon
                      icon="MoreVerticalIcon"
                      size="18"
                      class="text-body cursor-pointer"
                  />
                </template>
                <b-dropdown-item href="#">
                  ...
                </b-dropdown-item>
              </b-dropdown>
            </b-card-header>
            <b-card-body class="mb-0">
              <b-row>
                <b-col
                    xl="12"
                    md="12"
                    class="mb-2"
                >
                  <label
                      for="artista"
                      class="h5"
                  >Destinatario</label>
                  <b-row>
                    <b-col
                        xl="9"
                        md="9"
                    >
                      <ejs-dropdownlist
                          id="artista"
                          v-model="artistiActiveData.artista"
                          :dataSource="artistiFullData"
                          placeholder="Selezione Artista"
                          :fields="artistiIdFields"
                      />
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                    xl="12"
                    md="12"
                    class="mb-2"
                >
                  <label
                      for="tipocontratto"
                      class="h5"
                  >Tipo Contratto</label>
                  <b-row>
                    <b-col
                        xl="9"
                        md="9"
                    >
                      <ejs-dropdownlist
                          id="tipocontratto"
                          v-model="artistiActiveData.tipocontratto"
                          :dataSource="listaTipiContratto"
                          placeholder="Tipo Contratto"
                          :fields="tipoContrattoFields"
                      />
                    </b-col>
                  </b-row>
                </b-col>
                <b-col
                    xl="12"
                    md="12"
                    class="mb-2"
                >
                  <label
                      for="importo"
                      class="h5"
                  >Importo Complessivo</label>
                  <ejs-numerictextbox
                      id="importo"
                      v-model="artistiActiveData.importo"
                      floatLabelType="Never"
                      cssClass=""
                      format="€ ###.#"
                      placeholder="Importo"
                      showSpinButton="false"
                      showClearButton="true"
                  />
                </b-col>
                <b-col
                    xl="12"
                    md="12"
                    class="text-right mt-1"
                >
                  <ejs-button
                      id="generaContrattoButton"
                      cssClass="e-flat"
                      @click.native="dialogAButtonClick()"
                  >Genera
                  </ejs-button>
                </b-col>

              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </ejs-dialog>


    <!-- dialogB: dialogModificaContratto -->
    <ejs-dialog
        id="dialogB"
        ref="dialogB"
        :header="dialogB.header"
        :buttons="dialogB.buttons"
        :visible="dialogB.visible"
        :showCloseIcon="dialogB.showCloseIcon"
        :close="dialogBClose"
        :open="dialogBOpen"
        :zIndex="dialogB.zIndex"
        :animationSettings="dialogB.animationSettings"
    >
        <b-row class="match-height">

          <!-- Card con Elementi Input -->
          <b-col
              xl="12"
              md="12"
          >
            <b-card
                tag="article"
                class="mb-2"
            >
              <b-card-header class="align-items-baseline">
                <div>
                  <b-card-title>Modifica contratto</b-card-title>
                  <b-card-text class="mb-0" />
                </div>
                <b-dropdown
                    variant="link"
                    no-caret
                    right
                    class="chart-dropdown"
                    toggle-class="p-0"
                >
                  <template #button-content>
                    <feather-icon
                        icon="MoreVerticalIcon"
                        size="18"
                        class="text-body cursor-pointer"
                    />
                  </template>
                  <b-dropdown-item href="#">
                    ...
                  </b-dropdown-item>
                </b-dropdown>
              </b-card-header>
              <b-card-body class="mb-0">
                <!-- card body -->
                <b-row>

                  <!-- Input di tipo testo generico: imgArtistiActiveData.fileImmagine  -->
                  <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                  >
                    <label
                        for="bozzaContratto"
                        class="h5"
                    >Bozza Contratto</label>

                    <ejs-button
                        id="bozzaDownload"
                        cssClass="e-flat"
                        @click.native="dialogBDownloadBozza()"
                    >
                      Scarica il
                      File
                    </ejs-button>
                  </b-col>

                  <!-- Input di tipo file upload -->
                  <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                  >
                    <label
                        for="contrattoModificato"
                        class="h5"
                    >Contratto Modificato</label>
                    <ejs-uploader
                        id="contrattoModificato"
                        ref="uploadObj"
                        name="contrattoModificato"
                        :async-settings="dialogBFileUpload.path"
                        :allowed-extensions="dialogBFileUpload.extensions"
                        :removing="addJWTHeaders"
                        :auto-upload="true"
                        :uploading="dialogBonFileUpload"
                        :success="dialogBafterUpload"
                        :drop-area="dialogBFileUpload.dropElement"
                        :buttons="dialogBFileUpload.buttons"
                    />
                  </b-col>

                </b-row>
              </b-card-body>
            </b-card>
          </b-col>

        </b-row>
    </ejs-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import useJwt from '@/auth/jwt/useJwt'
// import bootstrap-Vue
import {
  LayoutPlugin, TabsPlugin, CardPlugin, DropdownPlugin, ImagePlugin, EmbedPlugin, TablePlugin, LinkPlugin, AlertPlugin, ProgressPlugin, ToastPlugin, FormGroupPlugin, FormInputPlugin, FormCheckboxPlugin, FormSelectPlugin, CarouselPlugin, FormRatingPlugin,
} from 'bootstrap-vue'
// import Vuexy

// import Syncfusion
import { enableRipple } from '@syncfusion/ej2-base'
import { Query } from '@syncfusion/ej2-data'
import {
  DateTimePickerPlugin, DateRangePickerPlugin, DatePickerPlugin, TimePickerPlugin,
} from '@syncfusion/ej2-vue-calendars'
import { ButtonPlugin, CheckBoxPlugin, SwitchPlugin } from '@syncfusion/ej2-vue-buttons'
import {
  TextBoxPlugin, NumericTextBoxPlugin, MaskedTextBoxPlugin, SliderPlugin, UploaderPlugin,
} from '@syncfusion/ej2-vue-inputs'
import {
  DropDownListPlugin, MultiSelectPlugin, ListBoxPlugin, CheckBoxSelection,
} from '@syncfusion/ej2-vue-dropdowns'
import { DialogPlugin } from '@syncfusion/ej2-vue-popups'
import {
  GridPlugin, Edit as GridEdit, Toolbar as GridToolbar, Sort as GridSort, Filter as GridFilter,
} from '@syncfusion/ej2-vue-grids'
import { DropDownButtonPlugin } from '@syncfusion/ej2-vue-splitbuttons'

const axios = require('axios')
// use bootstrap-vue
Vue.use(TabsPlugin)
Vue.use(CardPlugin)
Vue.use(LayoutPlugin)
Vue.use(DropdownPlugin)
Vue.use(ImagePlugin)
Vue.use(EmbedPlugin)
Vue.use(TablePlugin)
Vue.use(LinkPlugin)
Vue.use(AlertPlugin)
Vue.use(ProgressPlugin)
Vue.use(ToastPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(FormSelectPlugin)
Vue.use(CarouselPlugin)
Vue.use(FormRatingPlugin)
// use Syncfusion
Vue.use(TextBoxPlugin)
Vue.use(NumericTextBoxPlugin)
Vue.use(MaskedTextBoxPlugin)
Vue.use(SliderPlugin)
Vue.use(UploaderPlugin)
Vue.use(DateRangePickerPlugin)
Vue.use(DatePickerPlugin)
Vue.use(DateTimePickerPlugin)
Vue.use(TimePickerPlugin)
Vue.use(DropDownListPlugin)
Vue.use(MultiSelectPlugin)
Vue.use(ButtonPlugin)
Vue.use(CheckBoxPlugin)
Vue.use(SwitchPlugin)
Vue.use(DialogPlugin)
Vue.use(GridPlugin)
Vue.use(DropDownButtonPlugin)
Vue.use(ListBoxPlugin)
enableRipple(true)
// api
const demoContrattiUrl = '/demo/api/contratti'
const demoArtistaUrl = '/demo/api/artista'

export default Vue.extend({
  components: {
  },
  data() {
    return {
      // generali
      settings: {
        // formatoData: { type: 'date', format: 'dd/MM/yyyy' },
        formatoData: 'dd-MM-yyyy',
        formatoOra: { type: 'dateTime', format: 'HH:mm' },
        intervalloOra: 15,
        listboxSelectionSettings: { showCheckbox: true },
      },
      contrattiFullData: [],
      contrattiActiveId: 0,
      artistiActiveData: {},
      artistiDefaultData: {},
      artistiFullData: [],
      artistiIdFields: { text: 'etichetta', value: 'id' },
      listaTipiContratto: [{tipo: 'Tipo Scrittura', id: 1}, {tipo: 'Tipo Cachet', id: 2}, {tipo: 'Tipo Diritti', id: 3},{tipo: 'Tipo Ricevuta', id: 4}],
      tipoContrattoFields: { text: 'tipo', value: 'id' }, // specifica i campi da estrarre per popolare la lista dei ruoli
      /* text e' il campo di dataSource visualizzato, value e' il valore inviato */

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per dialogA
      dialogA: {
        header: '',
        visible: false,
        showCloseIcon: true,
        buttons: [{ click: this.dialogAOk, buttonModel: { content: 'OK', isPrimary: true } },
          { click: this.dialogACancel, buttonModel: { content: 'Cancel' } }],
        animationSettings: { effect: 'FadeZoom', duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabADialogAIndex: 0,
      },

      // per dialogB
      dialogB: {
        header: 'Modifica Contratto',
        visible: false,
        showCloseIcon: true,
        buttons: [{ click: this.dialogBOk, buttonModel: { content: 'OK', isPrimary: true } },
          { click: this.dialogBCancel, buttonModel: { content: 'Cancel' } }],
        animationSettings: { effect: 'FlipXUp', duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogBIndex: 0,
      },

      // dati per dialogB fileUpload
      dialogBFileUpload: {
        path: {
          saveUrl: `${process.env.VUE_APP_API_ENDPOINT + demoContrattiUrl}/upload`,
          removeUrl: `${process.env.VUE_APP_API_ENDPOINT + demoContrattiUrl}/remove`,
        },
        extensions: '.docx, .doc',
        dropElement: '.control-fluid',
        buttons: {
          browse: 'Seleziona un file',
        },
      },

      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: true,
          allowDeleting: true,
        },
        filterOptions: { type: 'Excel' },
        toolbarOptions: [
          {
            text: 'Nuovo',
            tooltipText: 'Inserisci nuovo contratto',
            prefixIcon: 'e-plus',
            id: 'new',
          },
          {
            text: 'Modifica',
            tooltipText: 'Modifica contratto',
            prefixIcon: 'e-expand',
            id: 'edit',
          },
          {
            text: 'Cancella',
            tooltipText: 'Cancella contratto',
            prefixIcon: 'e-cancel',
            id: 'delete',
          },
          {
            text: 'Scarica',
            tooltipText: 'Scarica contratto',
            prefixIcon: 'e-save',
            id: 'download',
          },
          'Search',
        ],
      },
    }
  },
  created() {
    this.currentArtista = {
      id: 0,
      nome: '',
      cognome: '',
      dataNascita: null,
      luogoNascita: '',
      nazionalita: '',
      codiceFiscale: '',
      numeroTelefono: '',
      altezza: null,
      peso: null,
      ratingEsperienza: 0,
      ratingPerformance: 0,
      immagineProfilo: 'https://picsum.photos/1024/400/?image=51',
      documenti: [],
      documentiSelezionati: [],
      convenzioni: [],
      convenzioniSelezionate: [],
      agente: null,
      under35: false,
      ruoliAbilitati: [],
    }

    console.log('Pagina Contratti Creata')
    // inizializzazione elenchi dal backend
    // chiamata API

    // recupero elenco artisti per popolare gridA (gridElencoArtisti)
    if (localStorage.getItem('userData') !== null) {
      console.log('Recupero elenco artisti dal backend per gridA')

      useJwt.get(demoContrattiUrl).then(d => {
        console.log('contratti')
        console.log(d.data)
        for (const i in d.data) {
          // aggiungi struct composta con i campi giusti
          console.log(d.data[i])
          console.log(d.data[i].artista)
          if (d.data[i].artista) {
            const val = {
              id: d.data[i].id,
              cognome: d.data[i].artista.cognome,
              nome: d.data[i].artista.nome,
              bozza: d.data[i].nomi_contratti.nomeBozza,
              urlBozza: d.data[i].fileDocumento,
              modificato: d.data[i].nomi_contratti.nomeModificato,
              urlModificato: d.data[i].contrattoModificato,
              firmato: d.data[i].nomi_contratti.nomeFirmato,
              urlFirmato: d.data[i].contrattoFirmato,
            }
            this.contrattiFullData.push(val)
          }
        }
        //console.log(this.contrattiFullData)
      })

      useJwt.get(demoArtistaUrl).then(d => {
        console.log('ARTISTI')
        console.log(d.data)
        // TODO: iterare in modo corretto
        for (const i in d.data) {
          // aggiungi struct composta con i campi giusti
          const val = d.data[i]
          val.etichetta = `${d.data[i].nome}  ${d.data[i].cognome}`

          this.artistiFullData.push(val)
        }
      })
      console.log('arrivo alla fine di created')
    } else {
      console.log('Non trovo UserData, prova ancora')
    }

    this.artistiDefaultData = {
      artista: { id: 0, value: '', etichetta: '' },
      tipocontratto: {},
      importo: 0,
    }
    // TODO: spostare i valori di default in file json separato?
    // Recupero/definisco i valori di default delle entità utilizzate nel componente
  },

  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit],
    // per listBox
    listbox: [CheckBoxSelection],
  },
  methods: {
    forceFileDownload(response, title) {
      console.log(title)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
    },
    downloadFile(url, title) {
      const uninterceptedAxiosInstance = axios.create()
      uninterceptedAxiosInstance.get(url,
        {
          responseType: 'arraybuffer',
          crossdomain: true,
        }).then(response => {
        this.forceFileDownload(response, title)
      }).catch(() => console.log('error occured'))
    },
    gridAactionBegin(e) {
      console.log('gridAactionBegin')
    },
    // Grid’s actionComplete event handler
    // Triggers after an action is completed
    gridAactionComplete(e) {
      console.log('gridAactionComplete')
    },
    gridAClickHandler(args) {
      console.log('gridAClickHandler()')
      if (args.item.id === 'new') {
        this.dialogA.header = 'Nuovo Contratto'
        // contratto corrente da inizializzare con info default
        console.log('Premuto pulsante creazione nuovo artista da gridA')
        // console.log(this.artistiActiveData);
        this.contrattiActiveId = 0
        this.$refs.dialogA.show(true)
      } else if (args.item.id === 'edit') {
        // TODO: ottimizzare con download la parte di ricerca
        let found = false
        console.log('edit')
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords()
          this.contrattiActiveId = selectedRow[0].id
          // console.log("gridA, Id selezionato:");
          console.log(this.contrattiActiveId)
          // TODO: sistemare iterazione
          for (const i in this.contrattiFullData) {
            if (this.contrattiFullData[i].id === this.contrattiActiveId) {
              console.log("id dell'elenco trovato:")
              console.log('CONTRATTO CORRENTE')
              console.log(this.contrattiFullData[i])
              this.contrattiActiveData = { ...this.contrattiFullData[i] }
              found = true
              break
            }
          }
        } catch (err) {
          console.log('Occorre selezionare una riga della tabella')
          this.alertAShow()
        }
        // if not found cosa?

        this.$refs.dialogB.show(true)
      } else if (args.item.id === 'delete') {

        const removeContrattoUrl = `${demoContrattiUrl}/remove`
        console.log('delete')
        const selectedRow = this.$refs.gridA.getSelectedRecords()
        console.log(selectedRow[0].id)

        useJwt.post(removeContrattoUrl, {'contratto_id': selectedRow[0].id}).then(res => {
          console.log(res.data)
          if (res.status === 204) {
            this.makeToast('primary', 'Contratto cancellato correttamente', '')
            this.$refs.gridA.ej2Instances.deleteRecord(); // cancella riga da grid
          } else {
            this.makeToast('primary', 'Attenzione', 'Errore nella cancellazione contratto')
          }
        })
      } else if (args.item.id === 'download') {
        let found = false
        console.log('download elemento')
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords()
          this.contrattiActiveId = selectedRow[0].id
          // console.log("gridA, Id selezionato:");
          console.log(this.contrattiActiveId)
          // TODO: sistemare iterazione
          for (const i in this.contrattiFullData) {
            if (this.contrattiFullData[i].id === this.contrattiActiveId) {
              console.log("id dell'elenco trovato:")
              console.log('CONTRATTO CORRENTE')
              console.log(this.contrattiFullData[i])
              this.contrattiActiveData = { ...this.contrattiFullData[i] }
              found = true
              break
            }
          }
        } catch (err) {
          console.log('Occorre selezionare una riga della tabella')
          this.alertAShow()
        }
        if (found) {
          this.downloadFile(this.contrattiActiveData.urlBozza, this.contrattiActiveData.bozza)
        } else {
          console.log('contratto non trovato')
        }
      }
    },
    dialogAOpen() {
      console.log('Apertura dialogA')
      this.artistiActiveData = this.artistiDefaultData
    },
    dialogAButtonClick() {
      const generaContrattiUrl = `${demoContrattiUrl}/genera`
      useJwt.post(generaContrattiUrl, this.artistiActiveData).then(res => {
        console.log(res.data)
        if (res.status === 201) {
          this.makeToast('primary', 'Contratto generato correttamente', '')
          const val = {
            id: res.data.id,
            cognome: res.data.artista.cognome,
            nome: res.data.artista.nome,
            bozza: res.data.nomi_contratti.nomeBozza,
            urlBozza: res.data.fileDocumento,
            modificato: res.data.nomi_contratti.nomeModificato,
            urlModificato: res.data.contrattoModificato,
            firmato: res.data.nomi_contratti.nomeFirmato,
            urlFirmato: res.data.contrattoFirmato,
          }
          this.contrattiFullData.push(val)
          this.contrattiFullData = [...this.contrattiFullData]
          this.$refs.dialogA.hide()
          // TODO: manca reset degli elementi del dialog
          this.artistiActiveData = this.artistiDefaultData
        } else {
          this.makeToast('primary', 'Attenzione', res.data.errors)
        }
      })
    },

    dialogAClose() {
      console.log('Chiusura dialogA')
    },

    // per dialogB
    dialogBOpenButtonClick() {
      this.$refs.dialogB.show(true)
    },
    dialogBOpen() {
      console.log('Apertura dialogB')
      // assegnare le informazioni da visualizzare nel dialogB
    },
    dialogBClose() {
      console.log('Chiusura dialogB')
    },
    dialogBOk() {
      console.log('Cliccato bottone OK di dialogB')
      this.$refs.dialogB.hide()
    },
    dialogBCancel() {
      console.log('Cliccato bottone Cancel di dialogB')
      this.$refs.dialogB.hide()
    },
    dialogBDownloadBozza() {
      console.log('Cliccato bottone Download Bozza')
      this.downloadFile(this.contrattiActiveData.urlBozza, this.contrattiActiveData.bozza)
    },
    dialogBonFileUpload(args) {
      const token = useJwt.getToken()

      useJwt.check() // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader('Authorization', `Bearer ${token}`)
      // add addition data as key-value pair.
      // eslint-disable-next-line no-param-reassign
      args.customFormData = [{ contratto_id: this.contrattiActiveData.id }]
    },
    dialogBafterUpload(args) {
      console.log(args)
      // TODO gestire successo upload nuovo contratto
      // if (args.name === 'success') {
      //   console.log('tutto a posto')
      //   console.log(args.e.target.response)
      //   const imgUrl = args.e.target.response.replace(/"/g, '') // rimuovi apici dalla risposta ottenuta dal backend
      //   this.imgArtistiActiveData.fileImmagine = imgUrl
      //   this.artistiActiveData.immagineProfilo = this.imgArtistiActiveData.fileImmagine
      //   // TODO: reload immagine?
      // }
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs
    },
    // per toast
    makeToast(variant = null, title = 'titolo', message = 'messaggio') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      })
    },
    // per file upload: ?? Serve differenziarli nei vari elementi fileUpload??
    addJWTHeaders(args) {
      const token = useJwt.getToken()

      useJwt.check() // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader('Authorization', `Bearer ${token}`)
    },

  },
})

/* eslint-disable global-require */
</script>

<style lang="scss" >
@import "~@syncfusion/ej2-base/styles/bootstrap.css";
@import "~@syncfusion/ej2-buttons/styles/bootstrap.css";
@import "~@syncfusion/ej2-vue-buttons/styles/bootstrap.css";
@import '~@syncfusion/ej2-calendars/styles/bootstrap.css';
@import '~@syncfusion/ej2-calendars/styles/datepicker/bootstrap.css';
@import '~@syncfusion/ej2-dropdowns/styles/bootstrap.css';
@import "~@syncfusion/ej2-vue-popups/styles/bootstrap.css";
@import "~@syncfusion/ej2-vue-navigations/styles/bootstrap.css";
@import '~@syncfusion/ej2-inputs/styles/bootstrap.css';
@import '~@syncfusion/ej2-vue-layouts/styles/bootstrap.css';
@import '~@syncfusion/ej2-vue-richtexteditor/styles/bootstrap.css';
@import '~@syncfusion/ej2-splitbuttons/styles/bootstrap.css';
@import '~@syncfusion/ej2-grids/styles/bootstrap.css';
@import "~@syncfusion/ej2-vue-spreadsheet/styles/bootstrap.css";
@import '~@syncfusion/ej2-schedule/styles/bootstrap.css';
@import "~@syncfusion/ej2-vue-documenteditor/styles/bootstrap.css";
@import "~@syncfusion/ej2-treegrid/styles/bootstrap.css";
@import "~@syncfusion/ej2-vue-gantt/styles/bootstrap.css";
@import "~@syncfusion/ej2-vue-diagrams/styles/bootstrap.css";
@import "~@syncfusion/ej2-vue-kanban/styles/bootstrap.css";

.e-btn-icon.e-open-icon {
  background: url('~@/assets/images/svg/open2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url('~@/assets/images/svg/garbage-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url('~@/assets/images/svg/download2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url('~@/assets/images/svg/search-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url('~@/assets/images/svg/upload-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url('~@/assets/images/svg/add2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}
</style>
